import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsThumbtackComponent } from './simple-icons-thumbtack.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsThumbtackComponent ],
    exports:      [ SimpleIconsThumbtackComponent ],
    bootstrap:    []
})
export class SimpleIconsThumbtackModule {}
